import { useTranslation } from "react-i18next";
import { CarConfiguration } from "../../../queries/models/car-configuration/car-configuration.model";
import { useEffect, useState } from "react";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { DeviceAttributeSelector } from "../io/DeviceAttributeSelector";
import { InstallationSelector } from "../../ui/InstallationSelector";

interface CarEditFormProps {
  value: CarConfiguration;
  onChange: (value: CarConfiguration) => void;
}

export function CarEditForm({ value, onChange }: CarEditFormProps) {
  const { t } = useTranslation();

  const [name, setName] = useState(value.name);
  const [maxChargingPower, setMaxChargingPower] = useState(
    value.maxChargingPower
  );
  const [capacity, setCapacity] = useState(value.capacity);
  const [homeInstallationId, setHomeInstallationId] = useState(
    value.homeInstallationId
  );
  const [socDeviceAttributeId, setSocDeviceAttributeId] = useState(
    value.socDeviceAttributeId
  );

  useEffect(() => {
    value.name = name;
    value.maxChargingPower = maxChargingPower;
    value.capacity = capacity;
    value.homeInstallationId = homeInstallationId;
    value.socDeviceAttributeId = socDeviceAttributeId;
    onChange(value);
  }, [
    value,
    name,
    maxChargingPower,
    capacity,
    homeInstallationId,
    socDeviceAttributeId,
    onChange,
  ]);

  return (
    <div className="flex flex-col grey-inputs" style={{ width: 600 }}>
      <label className="mt-2">{t("common.name")}</label>
      <InputText value={name} onChange={(e) => setName(e.target.value)} />
      <label className="mt-2">Max charging power [W]</label>
      <InputNumber
        value={maxChargingPower}
        onChange={(e) => setMaxChargingPower(e.value ?? 0)}
      />
      <label className="mt-2">Capacity [Wh]</label>
      <InputNumber
        value={capacity}
        onChange={(e) => setCapacity(e.value ?? 0)}
      />
      <label className="mt-2">Home Installation</label>
      <InstallationSelector
        allowEmpty={true}
        selectedInstallationId={homeInstallationId ?? undefined}
        onInstallationIdChange={(v) => setHomeInstallationId(v)}
      />
      <label className="mt-2">MQTT SoC Device Attribute ID</label>
      {homeInstallationId && (
        <DeviceAttributeSelector
          allowEmpty={true}
          installationId={homeInstallationId ? homeInstallationId : undefined}
          selectedDeviceAttributeId={socDeviceAttributeId ?? undefined}
          onDeviceAttributeIdChange={(v) => setSocDeviceAttributeId(v)}
        />
      )}
      {!homeInstallationId && (
        <div className="text-orange-500">
          Home installation is required to select a SoC device attribute.
        </div>
      )}
    </div>
  );
}
